import { RootState } from "store/store";
import { connect } from "react-redux";
import SearchBar from "./SearchBar";
import { setEnvironmentFilterSearch } from "store/filters/filters-actions";
import { getActiveEnvironmentId } from "store/environments/environment-selectors";
import { getActiveEnvironmentFilterSearchTextSelector } from "store/filters/filters-selectors";

const mapStateToProps = (state: RootState) => {
    return {
        activeEnvironmentId: getActiveEnvironmentId(state),
        searchText: getActiveEnvironmentFilterSearchTextSelector(state) || "",
    };
};
const SearchBarTenantsContainer = connect(mapStateToProps, {
    setSearchText: setEnvironmentFilterSearch,
})(SearchBar);

export default SearchBarTenantsContainer;
